import { getSVG } from './components/icons-loader.js';
import { showMoreFaqs, accordion } from './components/accordion.js';
import { videoLazyLoading } from './components/video.js'
import { displayCookieBanner } from './components/cookies-banner.js';

document.addEventListener("DOMContentLoaded", function () {
  accordion('.faqs-cards');
  showMoreFaqs();
  getSVG();
  videoLazyLoading();
  displayCookieBanner();
});
